import { Component, Host, h, Prop } from '@stencil/core';

/**
 * @slot - The content of the component.
 */
@Component({
  tag: 'o2-tab-content',
  styleUrl: 'tab-content.scss',
})
export class O2TabContent {
  /**
   * Name of the panel.
   */
  @Prop({ reflect: true }) name: string;

  /**
   * Defines actually selected tab-content.
   */
  @Prop({ reflect: true }) selected?: boolean = false;

  render() {
    return (
      <Host role="tabpanel">
        <div id={`tab-panel-${this.name}`} class="o2-tab-content" aria-labelledby={`tab-${this.name}`}>
          <slot></slot>
        </div>
      </Host>
    );
  }
}
